import { useNavigate } from "react-router-dom";
import SingleSelectKendoGrid from "../../Grid/Selectable/SingleSelectKendoGrid";
import PageHeader from "../../Layout/Header/PageHeader";
import { carrierUrls } from "../../URL/ApplicationUrls";
import { combinedUrls } from "../../URL/functions";
import CarrierGridColumns, { CARRIER_NAME_FIELD } from "./CarrierGridColumns";
import { CarrierOverviewItem } from "./CarrierOverviewItem";
import { defaultAddButton } from "../../Grid/Toolbar/DefaultAddButton";
import { defaultEditButton } from "../../Grid/Toolbar/DefaultEditButton";
import { createExportButton } from "../../Grid/ExcelExport/CreateExportButton";
import { AuthorizationPolicies } from "../../Auth/AuthorizationPolicy";

export default function CarrierOverview() {
  const navigate = useNavigate();

  const addCarrier = () => navigate(carrierUrls.addCarrier.uiPath);

  const editCarrier = (carrier: CarrierOverviewItem | undefined) =>
    carrier && navigate(carrierUrls.carrierWithId(carrier.Id).uiPath);

  const url = combinedUrls(carrierUrls.base.apiUrl, "KendoGrid");

  return (
    <>
      <PageHeader headerText="Carrier" />
      <SingleSelectKendoGrid
        localStorageKey="CarrierOverviewGrid_DataState"
        fetchUrl={url}
        columns={CarrierGridColumns()}
        idSelector={(carrier: CarrierOverviewItem) => carrier.Id}
        toolbarItems={[
          defaultAddButton({
            onClick: addCarrier,
            roles: AuthorizationPolicies.RequireAdminNetworkLaunchRoles,
          }),
          defaultEditButton({
            onClick: editCarrier,
            roles: AuthorizationPolicies.RequireAdminNetworkLaunchRoles,
          }),
        ]}
        initialSorting={{ field: CARRIER_NAME_FIELD, dir: "asc" }}
        onRowDoubleClick={editCarrier}
        customToolbarItems={[createExportButton({ url, filename: "Carriers" })]}
      />
    </>
  );
}
